import appConfig from 'assets/config.json';
import {
  DEFAULT_CPR_CROSS_SECTION_IMAGE_MANIFEST_TARGET,
  normalizeCprCrossSectionImageMode,
  type CprCrossSectionImageMode,
} from './cprImageResources';

type CprCrossSectionRuntimeConfig = {
  CPR_CROSS_SECTION_IMAGE_MODE?: unknown;
  CPR_CROSS_SECTION_IMAGE_MANIFEST_TARGET?: unknown;
};

const runtimeConfig = appConfig as CprCrossSectionRuntimeConfig;

export function getConfiguredCprCrossSectionImageMode(): CprCrossSectionImageMode {
  return normalizeCprCrossSectionImageMode(
    runtimeConfig.CPR_CROSS_SECTION_IMAGE_MODE,
  );
}

export function getConfiguredCprCrossSectionImageManifestTarget(): string {
  const target = runtimeConfig.CPR_CROSS_SECTION_IMAGE_MANIFEST_TARGET;
  return typeof target === 'string' && target.length > 0
    ? target
    : DEFAULT_CPR_CROSS_SECTION_IMAGE_MANIFEST_TARGET;
}
